(function() {
    "use strict";

    angular
        .module("showcaseApp")
        .controller("addressFilterController", addressFilterController);

    /** @ngInject */
    function addressFilterController($scope, $timeout, $translate, $element, systemConstants, $window) {
        var $ctrl = this;

        var inputTypes = ['button', 'field'];
        var defaultInputType = 'button';

        $ctrl.suggestions = [];
        $ctrl.showAll = false;
        $ctrl.LOCATION_DISPLAY_LIMIT = 2;
        $ctrl.cities = [];
        $ctrl.states = [];
        $ctrl.neighborhoods = [];
        $ctrl.streets = [];
        $ctrl.pointOfInterest = [];
        $ctrl.isMobile = $window.innerWidth <= systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;

        $element.on('hidden.bs.dropdown', function () {
            $ctrl.model = ""
            if ($ctrl.actionOnClose) {
                $ctrl.actionOnClose();
            }
        });

        $element.on('shown.bs.dropdown', function () {
            focusOnSearchInput()
        });

        function focusOnSearchInput() {
            var searchInput = $element[0].querySelector('#localization-input');
            if (searchInput) {
                searchInput.focus();
                searchInput.select();
            }
        }

        $ctrl.clearAllLocations = function (event) {
            event.stopPropagation();
            angular.forEach($ctrl.selectedLocations, function (location) {
                categorizeLocation(location);
            });

            $ctrl.selectedLocations = [];
            $ctrl.placeholder = $translate.instant('flyers.filters.localization.placeholder');

            if (typeof $ctrl.actionOnClose === 'function') {
                $timeout(function () {
                    $ctrl.actionOnClose();
                }, 0);
            }

            focusOnSearchInput();
        };

        $ctrl.addLocation = function (suggestion) {
            var place = suggestion.description;

            $ctrl.selectedLocations = $ctrl.selectedLocations || [];
            var isDuplicate = $ctrl.selectedLocations.some(function (location) {
                return location.address === place;
            });

            if (isDuplicate) {
                return;
            }

            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address: place }, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                    var viewport = results[0].geometry.viewport;
                    var polygons = {
                        latitudeLo: viewport.getSouthWest().lat(),
                        latitudeHi: viewport.getNorthEast().lat(),
                        longitudeLo: viewport.getSouthWest().lng(),
                        longitudeHi: viewport.getNorthEast().lng(),
                    };
                    $ctrl.suggestions = $ctrl.suggestions.filter(function (suggestion) {
                        return suggestion.description !== place;
                    });

                    var objectLocation = {
                        name: place,
                        address: place,
                        latitude: results[0].geometry.location.lat(),
                        longitude: results[0].geometry.location.lng(),
                        types: results[0].types || [],
                        polygons: polygons
                    };

                    if (objectLocation.types.includes("administrative_area_level_1")) {
                        polygons.state = results[0].address_components[0].short_name
                    }

                    $scope.$applyAsync(function () {
                        $ctrl.selectedLocations.push(objectLocation);
                        $ctrl.cities = $ctrl.cities.filter(function (city) {
                        return city.description !== place;
                        });

                        $ctrl.states = $ctrl.states.filter(function (state) {
                            return state.description !== place;
                        });

                        $ctrl.streets = $ctrl.streets.filter(function (street) {
                            return street.description !== place;
                        });

                        $ctrl.neighborhoods = $ctrl.neighborhoods.filter(function (neighborhood) {
                            return neighborhood.description !== place;
                        });

                        $ctrl.pointOfInterest = $ctrl.pointOfInterest.filter(function (pointOfInterest) {
                            return pointOfInterest.description !== place;
                        });
                    });
                }
            });
        };

        $ctrl.removeLocation = function (index) {
            var removedLocation = $ctrl.selectedLocations.splice(index, 1)[0];

            if ($ctrl.model) {
                categorizeLocation(removedLocation);
            }
        };

        $ctrl.shouldOpenDropdown = function () {
            return (
                $ctrl.selectedLocations && $ctrl.selectedLocations.length > 0 ||
                $ctrl.suggestions && $ctrl.suggestions.length > 0 ||
                $ctrl.cities && $ctrl.cities.length > 0 ||
                $ctrl.states && $ctrl.states.length > 0 ||
                $ctrl.neighborhoods && $ctrl.neighborhoods.length > 0 ||
                $ctrl.streets && $ctrl.streets.length > 0 ||
                $ctrl.pointOfInterest && $ctrl.pointOfInterest.length > 0
            );
        };

        $ctrl.getSelectedText = function () {
            if (!$ctrl.selectedLocations || $ctrl.selectedLocations.length === 0) {
                return $translate.instant('flyers.filters.localization.placeholder');
            }
            return $translate.instant($ctrl.selectedLocations[0].name);
        }

        $ctrl.getPlaceholderText = function () {
            if (($ctrl.selectedLocations && $ctrl.selectedLocations.length === 0) || $ctrl.selectedLocations == null) {
                return $translate.instant('flyers.detail.location');
            } else {
                return $translate.instant('flyers.detail.location') + ' | ';
            }
        };

        $ctrl.isLocationSelected = function (location) {
            return $ctrl.selectedLocations.some(function (selected) {
                return selected.address === location.address;
            });
        };

        $ctrl.truncateText = function (text, size) {
            return truncateText(text, size);
        }

        $ctrl.$onInit = function () {
            if (!$ctrl.inputType) {
                $ctrl.inputType = defaultInputType;
            } else if (!inputTypes.includes($ctrl.inputType)) {
                $ctrl.inputType = defaultInputType;
            }
        };

        function categorizeLocation(location) {
            if (!$ctrl.model) return;

            if (location.types.includes("sublocality") || location.name.split('-').length === 2) {
                $ctrl.neighborhoods.push({ description: location.address });
            } else if (location.types.includes("route")) {
                $ctrl.streets.push({ description: location.address });
            } else if (location.types.includes("point_of_interest")) {
                $ctrl.pointOfInterest.push({ description: location.address });
            } else if (location.types.includes("locality") || location.types.includes('administrative_area_level_2')) {
                $ctrl.cities.push({ description: location.address });
            }
        }
    }

})();
